import { useContext } from 'react';
import ApiClientContext from './ApiClientContext';

export default function useApiClient() {
  const context = useContext(ApiClientContext);
  return context;
}
